import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import EngineerLayout from './EngineerLayout';
import { db } from '../../firebase';
import { ref as dbRef, onValue, remove } from 'firebase/database';
import { 
  FaSearch,
  FaPlus,
  FaTrash,
  FaArrowLeft
} from 'react-icons/fa';
import { toast } from 'react-toastify';

const EngineerAbove10LCWorks = () => {
    const navigate = useNavigate();
    const [works, setWorks] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const entriesPerPage = 10;

    // Fetch existing works and filter for > 10 LC
    useEffect(() => {
        const worksRef = dbRef(db, 'ekamwatapzp/WorkNames');
        const unsubscribe = onValue(worksRef, (snapshot) => {
            if (snapshot.exists()) {
                const data = snapshot.val();
                let flattenedWorks = [];
                
                Object.entries(data).forEach(([meetingNum, meetingWorks]) => {
                    Object.entries(meetingWorks).forEach(([id, value]) => {
                        const tenderAmt = parseFloat(value.tenderAmount) || 0;
                        if (tenderAmt > 10) {
                            flattenedWorks.push({
                                id,
                                meetingNumber: meetingNum,
                                ...value
                            });
                        }
                    });
                });
                
                setWorks(flattenedWorks.reverse()); 
            } else {
                setWorks([]);
            }
            setLoading(false);
        });

        return () => unsubscribe();
    }, []);

    const handleDelete = async (work) => {
        if (window.confirm("तुम्ही हे काम हटवू इच्छिता का?")) {
            try {
                await remove(dbRef(db, `ekamwatapzp/WorkNames/${work.meetingNumber}/${work.id}`));
                toast.success("यशस्वीरीत्या हटवले!");
            } catch (error) {
                toast.error("त्रुटी: " + error.message);
            }
        }
    };

    const filteredWorks = works.filter(work => 
        work.workName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        work.id?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        work.taluka?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        work.schemeName?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const indexOfLastEntry = currentPage * entriesPerPage;
    const indexOfFirstEntry = indexOfLastEntry - entriesPerPage;
    const currentEntries = filteredWorks.slice(indexOfFirstEntry, indexOfLastEntry);
    const totalPages = Math.ceil(filteredWorks.length / entriesPerPage);

    return (
        <EngineerLayout>
            <div className="p-8 bg-[#f4f7fe] min-h-screen">
                {/* Header Section */}
                <div className="flex justify-between items-center mb-10">
                    <div className="flex items-center gap-4">
                        <button 
                            onClick={() => navigate('/engineer/work-names-list')}
                            className="p-2 bg-white rounded-full shadow-sm hover:bg-gray-50 transition text-gray-600 border border-gray-100"
                        >
                            <FaArrowLeft size={18} />
                        </button>
                        <h1 className="text-2xl font-bold text-gray-800 tracking-tight">Above 10 LC Works</h1>
                    </div>
                    <div className="text-sm font-medium text-gray-400">
                        Zilla Parishad / <span className="text-gray-500 font-bold">Above 10 LC Works</span>
                    </div>
                </div>

                {/* Table Card */}
                <div className="bg-white rounded shadow-sm border border-gray-100 p-8 max-w-[1600px] mx-auto overflow-hidden">
                    {/* Toolbar */}
                    <div className="flex flex-col md:flex-row justify-between items-center mb-8 gap-4">
                        <div className="flex bg-[#6c757d] rounded p-0.5">
                            <button className="px-4 py-1.5 text-white text-sm font-medium border-r border-gray-500 hover:bg-gray-600 transition">Copy</button>
                            <button className="px-4 py-1.5 text-white text-sm font-medium border-r border-gray-500 hover:bg-gray-600 transition">Excel</button>
                            <button className="px-4 py-1.5 text-white text-sm font-medium hover:bg-gray-600 transition">Print</button>
                        </div>
                        <div className="flex items-center gap-2">
                            <label className="text-sm font-medium text-gray-600">Search:</label>
                            <input 
                                type="text" 
                                className="border border-gray-200 rounded px-3 py-1.5 outline-none focus:border-blue-500 text-sm transition"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>
                    </div>

                    {/* Table */}
                    <div className="overflow-x-auto">
                        <table className="w-full border-collapse">
                            <thead>
                                <tr className="border-b border-gray-100 bg-gray-50/50">
                                    <th className="px-4 py-3 text-sm font-bold text-gray-800 text-left border border-gray-100">
                                        <div className="flex items-center gap-2 cursor-pointer"># <div className="flex flex-col text-[8px] opacity-30"><FaPlus className="rotate-180" /><FaPlus /></div></div>
                                    </th>
                                    <th className="px-4 py-3 text-sm font-bold text-gray-800 text-left border border-gray-100">
                                        <div className="flex items-center gap-2 cursor-pointer">ID <div className="flex flex-col text-[8px] opacity-30"><FaPlus className="rotate-180" /><FaPlus /></div></div>
                                    </th>
                                    <th className="px-4 py-3 text-sm font-bold text-gray-800 text-left border border-gray-100">
                                        <div className="flex items-center gap-2 cursor-pointer">Taluka <div className="flex flex-col text-[8px] opacity-30"><FaPlus className="rotate-180" /><FaPlus /></div></div>
                                    </th>
                                    <th className="px-4 py-3 text-sm font-bold text-gray-800 text-left border border-gray-100">
                                        <div className="flex items-center gap-2 cursor-pointer">Scheme Name <div className="flex flex-col text-[8px] opacity-30"><FaPlus className="rotate-180" /><FaPlus /></div></div>
                                    </th>
                                    <th className="px-4 py-3 text-sm font-bold text-gray-800 text-left border border-gray-100">
                                        <div className="flex items-center gap-2 cursor-pointer">Niveeda Rakkam <div className="flex flex-col text-[8px] opacity-30"><FaPlus className="rotate-180" /><FaPlus /></div></div>
                                    </th>
                                    <th className="px-4 py-3 text-sm font-bold text-gray-800 text-left border border-gray-100 min-w-[250px]">
                                        <div className="flex items-center gap-2 cursor-pointer">Name Of Work <div className="flex flex-col text-[8px] opacity-30"><FaPlus className="rotate-180" /><FaPlus /></div></div>
                                    </th>
                                    <th className="px-4 py-3 text-sm font-bold text-gray-800 text-left border border-gray-100">
                                        <div className="flex items-center gap-2 cursor-pointer">Work Add By <div className="flex flex-col text-[8px] opacity-30"><FaPlus className="rotate-180" /><FaPlus /></div></div>
                                    </th>
                                    <th className="px-4 py-3 text-sm font-bold text-gray-800 text-left border border-gray-100">
                                        <div className="flex items-center gap-2 cursor-pointer">Action <div className="flex flex-col text-[8px] opacity-30"><FaPlus className="rotate-180" /><FaPlus /></div></div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td colSpan="8" className="px-4 py-10 text-center text-gray-400">
                                            <div className="w-8 h-8 border-4 border-blue-600/30 border-t-blue-600 rounded-full animate-spin mx-auto"></div>
                                        </td>
                                    </tr>
                                ) : currentEntries.length === 0 ? (
                                    <tr>
                                        <td colSpan="8" className="px-4 py-16 text-center text-gray-600 font-medium">
                                            No data available in table
                                        </td>
                                    </tr>
                                ) : (
                                    currentEntries.map((work, index) => (
                                        <tr key={work.id} className="hover:bg-gray-50/50 transition-colors border-b border-gray-50 last:border-0 text-sm">
                                            <td className="px-4 py-4 border border-gray-100">{indexOfFirstEntry + index + 1}</td>
                                            <td className="px-4 py-4 border border-gray-100 font-medium text-gray-600 uppercase">{work.id?.slice(-6) || "-"}</td>
                                            <td className="px-4 py-4 border border-gray-100">{work.taluka || "-"}</td>
                                            <td className="px-4 py-4 border border-gray-100 text-blue-600 font-medium">{work.schemeName || "-"}</td>
                                            <td className="px-4 py-4 border border-gray-100 font-bold">{work.tenderAmount || "-"}</td>
                                            <td className="px-4 py-4 border border-gray-100 leading-relaxed max-w-md">{work.workName || "-"}</td>
                                            <td className="px-4 py-4 border border-gray-100 italic text-gray-500 text-xs">Engineer</td>
                                            <td className="px-4 py-4 border border-gray-100">
                                                <div className="flex items-center gap-3">
                                                    <button 
                                                        onClick={() => handleDelete(work)}
                                                        className="p-1.5 text-red-500 hover:bg-red-50 rounded transition"
                                                        title="Delete"
                                                    >
                                                        <FaTrash size={14} />
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>

                    {/* Footer */}
                    <div className="mt-8 flex flex-col md:flex-row justify-between items-center gap-4 border-t border-gray-100 pt-6">
                        <div className="text-sm font-medium text-gray-500">
                            Showing {indexOfFirstEntry + 1} to {Math.min(indexOfLastEntry, filteredWorks.length)} of {filteredWorks.length} entries
                        </div>
                        <div className="flex items-center gap-0.5">
                            <button 
                                disabled={currentPage === 1}
                                onClick={() => setCurrentPage(prev => prev - 1)}
                                className="px-4 py-1.5 bg-white border border-gray-200 rounded-l text-sm font-medium text-gray-400 hover:text-gray-600 hover:bg-gray-50 disabled:opacity-50 transition"
                            >
                                Previous
                            </button>
                            <button 
                                disabled={currentPage === totalPages || totalPages === 0}
                                onClick={() => setCurrentPage(prev => prev + 1)}
                                className="px-4 py-1.5 bg-white border border-gray-200 rounded-r text-sm font-medium text-gray-400 hover:text-gray-600 hover:bg-gray-50 disabled:opacity-50 transition"
                            >
                                Next
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </EngineerLayout>
    );
};

export default EngineerAbove10LCWorks;
